import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const ThreeDots = () => {
  return (
    <svg
      className={rootClassName}
      xmlns={'http://www.w3.org/2000/svg'}
      fill={'none'}
      viewBox={'0.8 0.71 10.32 2.37'}
    >
      <path
        d={
          'M2 3.08C1.63733 3.08 1.344 2.968 1.12 2.744C0.906667 2.52 0.8 2.232 0.8 1.88C0.8 1.53867 0.906667 1.26133 1.12 1.048C1.344 0.824 1.63733 0.712 2 0.712C2.37333 0.712 2.66133 0.824 2.864 1.048C3.07733 1.26133 3.184 1.53867 3.184 1.88C3.184 2.232 3.07733 2.52 2.864 2.744C2.66133 2.968 2.37333 3.08 2 3.08ZM5.96875 3.08C5.60608 3.08 5.31275 2.968 5.08875 2.744C4.87542 2.52 4.76875 2.232 4.76875 1.88C4.76875 1.53867 4.87542 1.26133 5.08875 1.048C5.31275 0.824 5.60608 0.712 5.96875 0.712C6.34208 0.712 6.63008 0.824 6.83275 1.048C7.04608 1.26133 7.15275 1.53867 7.15275 1.88C7.15275 2.232 7.04608 2.52 6.83275 2.744C6.63008 2.968 6.34208 3.08 5.96875 3.08ZM9.9375 3.08C9.57483 3.08 9.2815 2.968 9.0575 2.744C8.84417 2.52 8.7375 2.232 8.7375 1.88C8.7375 1.53867 8.84417 1.26133 9.0575 1.048C9.2815 0.824 9.57483 0.712 9.9375 0.712C10.3108 0.712 10.5988 0.824 10.8015 1.048C11.0148 1.26133 11.1215 1.53867 11.1215 1.88C11.1215 2.232 11.0148 2.52 10.8015 2.744C10.5988 2.968 10.3108 3.08 9.9375 3.08Z'
        }
        fill={'currentColor'}
      ></path>
    </svg>
  );
};
